import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle, User } from "lucide-react";

/**
 * TillNoticeModal — pops up the moment a cashier selects a customer whose
 * `till_notice` is set. Cashier must click "Got it, continue" to dismiss;
 * transaction flow only proceeds afterwards.
 */
export const TillNoticeModal = ({ open, onClose, customer }) => {
  if (!customer) return null;
  const notice = (customer.till_notice || "").trim();
  if (!notice) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md border-2 border-amber-400" data-testid="till-notice-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertCircle className="h-5 w-5" />
            Notice for this customer
          </DialogTitle>
        </DialogHeader>

        <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 mb-3 flex items-center gap-2">
          <User className="h-4 w-4 text-amber-700" />
          <div className="min-w-0">
            <div className="font-semibold text-sm text-slate-900 truncate">
              {customer.name}
            </div>
            {customer.account_number && (
              <div className="text-xs text-slate-500">Acc: {customer.account_number}</div>
            )}
          </div>
        </div>

        <div
          className="text-base font-medium text-slate-900 whitespace-pre-wrap bg-white border rounded-lg p-3"
          data-testid="till-notice-text"
        >
          {notice}
        </div>

        <div className="flex justify-end mt-4">
          <Button
            onClick={onClose}
            className="bg-amber-500 hover:bg-amber-600 text-white"
            autoFocus
            data-testid="till-notice-dismiss"
          >
            Got it, continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TillNoticeModal;
